<div class="h-10 w-full flex items-center bg-white">
    <div class="container flex flex-row gap-2 ps-4">
        <ng-container *ngFor="let breadcrumb of this.breadcrumbs(); last as last">
            <div class="flex flex-row items-center gap-2" *ngIf="!last">
                <a class="text-default-blue/50 text-base" [routerLink]="breadcrumb.url">{{ breadcrumb.label|translate }}</a>
                <app-icon class="text-default-blue/50 fill-current" name="arrow-rounded-right-6x9" size="6x9"></app-icon>
            </div>
            <div *ngIf="last" class="text-default-blue text-base">{{ breadcrumb.label|translate }}</div>
        </ng-container>
    </div>
</div>